import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import LinkStatusIndicator from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/LinkStatusIndicator';
import FinancialInstitutionImagePicker from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/FinancialInstitutionImagePicker';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    padding: theme.spacing(2),
  },
  headerImageContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  linkStatusIndicator: {},
  institutionType: {
    marginLeft: theme.spacing(2),
  },
});

const Header = ({
  className,
  classes,
  lineItemResource,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <div className={classes.headerImageContainer}>
        <FinancialInstitutionImagePicker
          resource={lineItemResource}
          width={'100'}
          height={'auto'}
        />
        <Typography
          className={classes.institutionType}
        >
          {lineItemResource.attr('title')}
        </Typography>
      </div>
      <LinkStatusIndicator
        className={classes.linkStatusIndicator}
        lastUpdated={lineItemResource.attr('lastSync')}
        linkStatus={lineItemResource.attr('status')}
      />
    </Box>
  );
};

Header.defaultProps = {
  className: '',
};

Header.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  lineItemResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(Header);
